import React from "react";

function PriceSummary({
  basePrice,
  colorPrice = 0,
  lengthPrice = 0,
  sizePrice = 0,
  braidCountPrice = 0,
  braidCountIsFullPrice = false,
  washPrice = 0,
  total,
}) {
  return (
    <div className="price-summary">
      <h2>Price Summary</h2>

      {braidCountIsFullPrice ? (
        <div className="price-row">
          <span>Number of braids</span>
          <span>${basePrice}</span>
        </div>
      ) : (
        <div className="price-row">
          <span>Base price</span>
          <span>${basePrice}</span>
        </div>
      )}

      {colorPrice > 0 && (
        <div className="price-row">
          <span>Color</span>
          <span>+${colorPrice}</span>
        </div>
      )}

      {lengthPrice > 0 && (
        <div className="price-row">
          <span>Length</span>
          <span>+${lengthPrice}</span>
        </div>
      )}

      {sizePrice > 0 && (
        <div className="price-row">
          <span>Size</span>
          <span>+${sizePrice}</span>
        </div>
      )}

      {braidCountPrice > 0 && (
        <div className="price-row">
          <span>Additional braids</span>
          <span>+${braidCountPrice}</span>
        </div>
      )}

      {washPrice > 0 && (
        <div className="price-row">
          <span>Hair wash</span>
          <span>+${washPrice}</span>
        </div>
      )}

      <hr />

      <div className="price-row total">
        <strong>Total</strong>
        <strong>${total}</strong>
      </div>
    </div>
  );
}

export default PriceSummary;